module.exports = __webpack_public_path__ + "static/steve-jobs-b26a040a6fa00d68a68dcf6b8a6c9a3c.jpg";